import { useOverlayStack } from "./useOverlayStack";
import QuantityOverlay from "../components/overlay/QuantityOverlay.vue";

export type QuantityPromptOptions = {
  title: string;
  subtitle?: string | null;
  icon?: string;
  min: number;
  max: number;
  step?: number;
  initial?: number;
  confirmLabel?: string;
  helperText?: string | null;
  closeOnScrim?: boolean;
};

export function useQuantityPrompt() {
  const overlays = useOverlayStack();

  function promptQuantity(options: QuantityPromptOptions): Promise<number | null> {
    return new Promise((resolve) => {
      let result: number | null = null;

      const id = overlays.push({
        kind: "confirm",
        component: QuantityOverlay,
        props: {
          title: options.title,
          subtitle: options.subtitle ?? null,
          icon: options.icon,
          min: options.min,
          max: options.max,
          step: options.step ?? 1,
          initial: options.initial ?? options.min,
          confirmLabel: options.confirmLabel ?? "Confirm",
          helperText: options.helperText ?? null,
          closeOnScrim: options.closeOnScrim ?? true,
          onConfirm: (value: number) => {
            result = value;
            overlays.close(id, "action");
          }
        },
        onClose: () => {
          resolve(result);
        }
      });
    });
  }

  return { promptQuantity };
}
